import { render } from "./list.vue?vue&type=template&id=cdcd894a&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"

import "./list.vue?vue&type=style&index=0&id=cdcd894a&scoped=true&lang=css"
import "./list.vue?vue&type=style&index=1&id=cdcd894a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdcd894a"]])

export default __exports__